const setDashboardLiveTrendChannelNos = (state, action) => {
  state.dashboardLiveTrendChannelNos = action.payload;
}

const setIsOpenLiveTrendEditPage = (state, action) => {
  state.isOpenLiveTrendEditPage = action.payload;
}

const setIsDashboardLiveTrendFetching = (state, action) => {
  state.isDashboardLiveTrendFetching = {
    ...state.isDashboardLiveTrendFetching,
    [action.payload]: true,
  }
}

export default {
  setDashboardLiveTrendChannelNos, 
  setIsOpenLiveTrendEditPage, 
  setIsDashboardLiveTrendFetching
};